import { BaseTable } from '../common-models/base-table.model';
import tableSettings from './settings/bonus-table.settings';
import tableDictionary from './dictionary/calibration-bonus.dictionary';
import { TableType } from '../../../shared/enums';
import * as _ from 'lodash';
import { CalibrationBonusValue } from '../calibrations/calibration-bonus-value.model';

export class BonusTable extends BaseTable {

    constructor() {
        super(tableSettings, tableDictionary);
        this.calibrationType = TableType.CALIBRATION_BONUS;
    }

    public updateData(savedData: CalibrationBonusValue[]): boolean {
        if (!this.isInitialized) {
            return false;
        }
        savedData.forEach((updatedCalibrationBonus) => {
            const calibrationGeneralIndex =
                _.findIndex(this.table, (cell) => {
                    return cell.value.currentState.ZoneCombinationId === updatedCalibrationBonus.ZoneCombinationId &&
                        cell.value.currentState.OverlayTypologyId === updatedCalibrationBonus.OverlayTypologyId;
                });
            this.table[calibrationGeneralIndex].value =
                new CalibrationBonusValue(updatedCalibrationBonus, this.settings.fieldValidation);
        });
        return true;
    }
}
